import Vue from 'vue';

import { http } from '@/axios';
import router from '../router/router';
import { authHeader } from '../helpers';

export default {
  async signUserIn({ dispatch, commit }, payload) {
    commit('setLoading', true);
    commit('setError', { value: false });

    let rv = null;
    const { usuario, password } = payload;
    try {
      rv = await http.put('/usuarios/login', {
        usuario: {
          login: usuario,
          password: password,
        },
      });
      dispatch('autoSignIn', rv.entity);
    } catch (e) {
      console.log(' ERROR');
      console.log(e.toString());
      if (e.toString().includes('El Usuario no tiene una clave generada')) {
        if (
          confirm(
            'El usuario no tiene una clave generada. Se pasará a la pantalla de modificación de contraseña ¿Desea continuar?'
          )
        ) {
          router.replace(
            {
              name: 'changePassword',
              params: {
                login: usuario,
                currentPassVisible: false,
              },
            },
            commit('setError', { value: false })
          );
        }
      }

      commit('setError', { value: true, message: e });
    }

    commit('setLoading', false);
  },
  async logout({ commit }, payload) {
    commit('logout');

    localStorage.removeItem('token');
    delete http.defaults.headers.common['Authorization'];

    Vue.$log.debug('logout');

    router.push('/login');
  },
  async setAmbiente({ commit }, payload) {
    localStorage.setItem('ambiente', JSON.stringify(payload));
    commit('setAmbiente', payload);
  },

  async autoSignIn({ commit, state }, payload) {
    var usuario = {
      id: payload.id,
      login: payload.login,
      nombre: payload.nombre,
      email: payload.email,
      token: payload.token,
      puedeAutorizar: payload.puedeAutorizar,
      puedeTomarCasoGestion: payload.puedeTomarCasoGestion,
      tipoGestionId: payload.tipoGestionId,
      car: payload.car,
      iniciales: payload.iniciales,
      esComer: payload.esComer,
      esOnline: payload.esOnline,
      esConcentrador: payload.esConcentrador,
      esComercio: payload.esComercio,
      modalidadAltaConsultaId: payload.modalidadAltaConsultaId,
      accesoTodosCanalesVenta: payload.accesoTodosCanalesVenta,
      sectorDescripcion: payload.sectorDescripcion,
      roles: payload.roles,
      rules: { '*': ['*'] },
    };

    localStorage.setItem('user', JSON.stringify(usuario));

    try {
      // Vue.$log.debug('its here');
      http.defaults.headers.common['Authorization'] = authHeader();

      // el usuario se logueó correctamente, ahora busco la configuración de menúes
      var uiConfig = await http.get('/ConfiguracionUi?login=' + usuario.login);

      // el usuario se logueó correctamente, ahora busco la configuración general
      var parametrosGenerales = await http.get('/parametrosgenerales');

      commit('setUser', usuario);
      commit('setLayout', 'layout-admin');

      commit('setUiConfig', uiConfig.list);
      commit('setUiSettings', payload.uiSettings);
      commit('setParametrosGenerales', parametrosGenerales);

      router.push(state.redirect || '/');
    } catch (e) {
      Vue.$log.error(e);
      commit('setError', { value: true, message: e });
    }
  },
  clearError({ commit }) {
    commit('setError', { value: false });
  },
  async setStatusTareaFrecuente({ commit, state }, action) {
    try {
      await http.put('ConfiguracionUi/updateaccionfrecuente', {
        accionFrecuenteUsuario: {
          usuarioId: state.user.id,
          accionId: action.accionId,
          agregar: action.esFrecuente ? false : true,
        },
      });

      action.esFrecuente = !action.esFrecuente;
      if (action.esFrecuente)
        commit(
          'alertSuccess',
          'Se ha agregado ' +
            action.accionDescripcion +
            ' a las Tareas Frecuentes'
        );
      else
        commit(
          'alertSuccess',
          'Se ha quitado ' +
            action.accionDescripcion +
            ' de las Tareas Frecuentes'
        );
    } catch (e) {
      commit('alertError', e);
    }
  },
  async setUiCustomUserSettings({ commit, state }, uiSettings) {
    try {
      await http.put(
        '/usuarios/actualizaruisettings',
        JSON.stringify({ uiSettings: state.UiCustomUserSettings })
      );

      commit('setUiSettings', uiSettings);

      commit('alertSuccess', 'Se ha guardado la configuración correctamente.');
    } catch (e) {
      commit('alertError', e);
    }
  },
  async setUserCAR({ commit }, user) {
    try {
      commit('setUser', user);

      await http.put(
        '/usuarios/actualizarcar',
        JSON.stringify({ usuario: { login: user.login, car: user.car } })
      );

      commit('alertSuccess', 'Se ha registrado el CAR correctamente.');
      return true;
    } catch (e) {
      commit('alertError', e);
      return false;
    }
  },
  async buscarPersonaPorNombre({ commit }, nombre) {
    try {
      commit('setLoading', true);
      var result = await http.get('personas/listapornombre?nombre=' + nombre);
      commit('setLoading', false);

      if (result.count >= 1) {
        commit('setListaPersonas', result.list);
      } else {
        commit('setPersonaBusqueda', null);
        commit('setListaPersonas', null);
        commit(
          'alertWarning',
          'No se encontraron personas con el nombre ingresado.'
        );
      }
    } catch (e) {
      // Error
      commit('alertError', e);
    }
  },
  async buscarPersonaPorCui({ commit }, payload) {
    try {
      console.log(payload);
      let cui = payload.cui;
      let allowNuevo = payload.allowNuevo;
      let alertPersonaInexistente = payload.alertPersonaInexistente;

      if (isNaN(Number.parseFloat(cui))) {
        commit('alertWarning', 'Debe ingresar un número.');
      } else {
        var result = await http.get(
          'personas/listaporcui?cui=' + Number.parseFloat(cui)
        );

        console.log('buscarPersonaPorCui');

        if (result.count >= 1) {
          commit('setListaPersonas', result.list);
        } else {
          if (alertPersonaInexistente) {
            commit('setPersonaBusqueda', null);
            commit('setListaPersonas', null);

            commit(
              'alertWarning',
              'No se encontraron personas con el Documento o CUI ingresado.'
            );
          } else {
            if (allowNuevo) {
              console.log('persona no encontrada 1');
              commit('setPersonaBusqueda', {
                esNuevo: true,
                cui: cui,
                nombre: '',
                nombreCompleto: '',
              }); //  devuelvo a una persona vacía
            } else {
              console.log('persona no encontrada 2');
              commit('setPersonaBusqueda', null); //  devuelvo a una persona vacía
              commit('setListaPersonas', null);
            }
          }
        }
      }
    } catch (e) {
      // Error
      commit('alertError', e);
    }
  },
  async cancelarAnalisis({ commit }, creditoId) {
    commit('setLoading', true);
    try {
      var params = {};
      params.creditoId = creditoId;
      params.tomado = false;

      await http.post(
        'creditos/cambiarestadotomaanalisis',
        JSON.stringify({ parametros: params })
      );

      commit('alertSuccess', 'Se canceló la toma del crédito.');
    } catch (error) {
      // Error
      commit('alertError', error);
    }
    commit('setLoading', false);
  },
  async openFilePoliticasRiesgo({ commit }) {
    http
      .get('filemanagement/getfilepoliticasriesgo/')
      .then((resp) => {
        if (resp.extension === '.pdf' || resp.extension === '.PDF') {
          let pdfWindow = window.open('');
          pdfWindow.document.write(
            "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
              resp.file +
              "'></iframe>"
          );
        } else {
          commit('alertError', 'El archivo no es un PDF. Verifique');
        }
      })
      .catch((e) => {
        commit('alertError', e);
      });
  },
  async openNotificacionesGenerales({ commit, state }) {
    http
      .get('filemanagement/getfilenotificacionesgenerales/')
      .then((resp) => {
        if (resp.extension === '.pdf' || resp.extension === '.PDF') {
          let pdfWindow = window.open('');
          pdfWindow.document.write(
            "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
              resp.file +
              "'></iframe>"
          );
          console.log('2');
          state.UiCustomUserSettings.fechaVisualizacionNotificacion = new Date();
          console.log('1');
          commit('setUiSettings', state.UiCustomUserSettings);
        } else {
          commit('alertError', 'El archivo no es un PDF. Verifique');
        }
      })
      .catch((e) => {
        commit('alertError', e);
      });
  },
};
